module.exports = __webpack_public_path__ + "img/logo.73180454.png";